import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { User, Calendar, AlertCircle, Zap, Receipt } from "lucide-react";
import { format } from "date-fns";
// import EditDealModal from "../../pages/deals/deal/add-edit-modal/EditDealModal";
import NewEyeIcon from "../icons/action-eye-icon";
import NewCardIcon from "../icons/action-card-icon";
import DotsVerticalIcon from "../icons/dots-vertical";
import NewEditIcon from "../icons/action-edit-icon";
import { Link } from "react-router";
import EmployeeDirectoryAddUpdate from "../../pages/organization/emplyee-directory/add-update";
import { useClickOutside } from "../custom-hooks/click-outside";

const priorityConfig = {
  Critical: {
    color: "bg-red-100 text-red-700 border-red-200",
    icon: AlertCircle,
  },
  High: { color: "bg-orange-100 text-orange-700 border-orange-200", icon: Zap },
  Medium: { color: "bg-blue-100 text-blue-700 border-blue-200", icon: null },
  Low: { color: "bg-slate-100 text-slate-600 border-slate-200", icon: null },
};

export default function DealCard({
  deal,
  onClick,
  isDragging,
  accentHexColor,
  colors,
  onDealUpdated = () => {}, // refresh after update
  onSubmit = () => {},
  onError2 = () => {},
  onToggle = () => {},
  isOpen = {}
}) {
  const priority = priorityConfig[deal.priority] || priorityConfig["Medium"];
  const PriorityIcon = priority.icon;

  const [edit, setEdit] = useState(false);

  const editDeal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEdit(true);
    // console.log("complete deal", deal?.completeDeal);
  };

  // const [Menu, showMenu] = useState(false);

  // const menuRef = useRef(null);

  // useClickOutside(menuRef, () => {
  //   setTimeout(() => {
  //     setActiveCardId(null);
  //     console.log("Handle out side click");
  //   }, 200);
  // });

  return (
    <>
      <motion.div
        whileHover={{ scale: 1.01, y: 0 }}
        whileTap={{ scale: 0.99 }}
        className={`flex p-4 rounded-lg border border-[#E1E4EA] bg-[#fff] transition-all duration-300   ${
          isDragging ? "shadow-md" : "hover:shadow-md"
        }`}
        style={{
          borderLeftColor: accentHexColor,
          boxShadow: isDragging
            ? `0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 0 0 1px ${accentHexColor}`
            : "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="space-y-4 w-full -z-0">
          {/* Header */}

          {/* Header */}
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <h4
                className={`font-bold text-slate-900 text-sm leading-tight truncate border-l-2  border-l-[${
                  colors?.color ? colors?.color : "#9D5FEF"
                }] p-2`}
                style={
                  colors?.color
                    ? { borderColor: colors?.color }
                    : { borderColor: "#9D5FEF" }
                }
              >
                {deal?.contact_name}
                <p className="text-xs text-slate-500 truncate">
                  {deal?.deal_package || "-"}
                </p>
              </h4>
            </div>
            <div className="flex gap-1  p-2 z-50">
              <div>
                <div
                  // ref={menuRef}
                  className="-mr-4 transition-all duration-300 hover:text-gray-500 relative cursor-pointer"
                  onClick={(e) => {
                    e?.stopPropagation();
                    onToggle();
                  }}
                >
                  <DotsVerticalIcon />

                  {isOpen ? (
                    <div
                      className={`border border-white shadow-xl absolute right-0 flex cursor-pointer  ${isOpen ? "opacity-1" : "opacity-0"}`}
                    >
                      {deal?.current_stage == "Won" ||
                      deal?.current_stage == "Lost" ? null : (
                        <div className="d-flex align-items-center gap-1">
                          <div
                            className={`w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300 
                                                      ${
                                                        deal?.current_stage ===
                                                          "Won" ||
                                                        deal?.current_stage ===
                                                          "Lost"
                                                          ? "opacity-50 cursor-not-allowed"
                                                          : ""
                                                      }`}
                            disabled={
                              deal?.current_stage === "Won" ||
                              deal?.current_stage === "Lost"
                            }
                            onClick={
                              deal?.current_stage == "Won" ||
                              deal?.current_stage == "Lost"
                                ? null
                                : (e) => {
                                    editDeal(e);
                                  }
                            }
                          >
                            <div
                              className="flex"
                              style={{ color: "#FF9500" }}
                              onClick={() => {
                                onToggle();
                              }}
                            >
                              <NewEditIcon className="h-4.5 w-4.5" />
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="d-flex align-items-center gap-1">
                        <div
                          className={
                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                          }
                          onClick={() => {
                            onClick(deal);
                          }}
                        >
                          <div
                            className="flex"
                            style={{ color: "#007AFF" }}
                            onClick={() => {
                              onToggle();
                            }}
                          >
                            <NewEyeIcon className="h-4.5 w-4.5" />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center gap-1">
                        <Link
                          // to={`/deals/dealDetail/${deal?.id}`}
                          // to={
                          //   deal?.deal_type === "account"
                          //     ? `/accounts/account-details/${deal?.completeDeal?.contactid}`
                          //     : `/contacts/contact-details/${deal?.completeDeal?.contactid}`
                          // }
                          // state={{
                          //   defaultDealId: deal?.id,
                          // }}
                          to={`/lead-account/detail/${deal?.completeDeal?.contactid}/deal/${deal?.id}`}
                          target="_blank"
                          className={
                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                          }
                        >
                          <div
                            className="flex"
                            style={{ color: "#34C759" }}
                            onClick={() => {
                              onToggle();
                            }}
                          >
                            <NewCardIcon className="h-4.5 w-4.5" />
                          </div>
                        </Link>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              <Receipt color="#53d20f" className="w-4 h-4" />

              <span className="font-semibold text-sm text-slate-800">
                {deal.deal_value
                  ? `$${deal.deal_value.toLocaleString()}`
                  : "No value"}
              </span>
            </div>

            {deal?.contact_name && (
              <div className="flex items-center gap-1">
                <User size={16} color="#a09c9c" strokeWidth={2.5} />
                <span className="text-sm text-slate-600 truncate max-w-20">
                  {deal?.contact_name ?? "-"}
                </span>
              </div>
            )}
          </div>

          <div className="flex items-center justify-between pt-2 border-t border-slate-300 ">
            <div className="flex items-center gap-1">
              <Calendar size={20} color="#a09c9c" strokeWidth={2.5} />
              <span className="text-xs  font-medium leading-9">
                {deal?.deal_date
                  ? format(new Date(deal?.deal_date), "MMM d")
                  : "-"}
              </span>
            </div>

            <div className="flex items-center gap-1 h-full">
              <div
                className={`w-6 h-6 bg-[${
                  colors?.color ? colors.color : "#9D5FEF"
                }] rounded-full flex items-center justify-center shadow-sm`}
                style={
                  colors?.color
                    ? { backgroundColor: colors?.color }
                    : { backgroundColor: "#9D5FEF" }
                }
              >
                <span className="text-xs font-bold text-white">
                  {deal?.assigned_to && deal?.assigned_to.trim() !== "" ? (
                    deal?.assigned_to[0]?.toUpperCase()
                  ) : (
                    <User size={16} color="white" strokeWidth={2.5} />
                  )}
                </span>
              </div>
              <span className="text-xs  font-medium truncate max-w-20 leading-9">
                {deal?.assigned_to && deal?.assigned_to.trim() !== ""
                  ? deal?.assigned_to
                  : "Not Assigned"}
              </span>
            </div>
          </div>
        </div>
      </motion.div>

      {edit && (
        <EmployeeDirectoryAddUpdate
          open={edit}
          onClose={() => {
            setEdit(false);
          }}
          data={deal?.completeDeal}
          tabIndex={1}
          contactId={deal?.completeDeal?.contactid}
          onDealUpdated={onDealUpdated}
          onSubmit={onSubmit}
          onError={onError2}
        />
      )}
    </>
  );
}
